import { RouteConfig } from "vue-router";

export const REmployeeServices: RouteConfig = {
  path: "services",
  name: "EmployeeServices",
  component: () =>
    import(
      /* webpackChunkName: "employee-services" */
      "./VEmployeeServices.vue"
    ),
  meta: {
    title: "Services",
    icon: "briefcase-outline",
    newIcon: "briefcase",
    version: 2,
  },
};
